// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"893":"6566a1cb","976":"9d2fd91b"}[chunkId] + ".chunk.js";
};